import React, { useState, useEffect } from "react";
import { Container, FormGroup, Label, Input, Modal, ModalHeader, ModalBody, ModalFooter, Col } from "reactstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Loading } from "../../share/loading";
import TextErrors from '../../share/TextErrors'
import CreateTableComponent from "../../share/CreateTableComponent";
import * as Yup from "yup";
import "../../share/form.css";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from "uuid";
import { BsPlusLg } from "react-icons/bs";
import { useSearchParams, useNavigate } from "react-router-dom";
import { format } from 'date-fns'
import DatePicker, { registerLocale } from "react-datepicker";
import th from 'date-fns/locale/th';
import getYear from "date-fns/getYear";
import getMonth from "date-fns/getMonth";
import { th as thBuddhist } from 'date-fns/esm/locale';
import { addYears } from 'date-fns/esm/fp';
import 'react-datepicker/dist/react-datepicker.css'

export function ExtendBorrowFormComponent() {
  registerLocale('th-buddhist', { ...th, options: { ...th.options, weekStartsOn: 1 }, formatLong: thBuddhist.formatLong })
  const range = (start, end) => {
    return new Array(end - start).fill().map((d, i) => i + start);
  };
  const thaiMonths = [
    "มกราคม",
    "กุมภาพันธ์",
    "มีนาคม",
    "เมษายน",
    "พฤษภาคม",
    "มิถุนายน",
    "กรกฎาคม",
    "สิงหาคม",
    "กันยายน",
    "ตุลาคม",
    "พฤศจิกายน",
    "ธันวาคม"
  ];

  // const years = range(1990, getYear(new Date()));
  const years = range(1963, getYear(new Date()) + 8, 1);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  let borrowId = searchParams.get("req")
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const user = JSON.parse(localStorage.getItem("userData"));
  const [borrowInfo, setBorrowInfo] = useState([]);
  const [courseData, setCourseData] = useState([]);
  const [classData, setClassData] = useState([]);
  const [lawOcuuByBorrowIdData, setLawOcuuByBorrowIdData] = useState([]);
  const [testTimeData, setTestTimeData] = useState([]);

  // สำหรับใส่ที่อยู่ปัจจุบันที่ติดต่อได้
  const [province, setProvince] = useState([]);
  const [amphur, setAmphur] = useState([]);
  const [tumbon, setTumbon] = useState([]);

  const [detailExtendCourseData, setDetailExtendCourseData] = useState([]);
  const [detailExtendLawOccupationData, setDetailExtendLawOccupationData] = useState([]);

  const [selectedItem, setSelectedItem] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  const [selectedTestItem, setSelectedTestItem] = useState(null);
  const [isTestEditing, setIsTestEditing] = useState(false);

  // toggle ดำเนินการฝึกอบรม
  const [openModalForm, setOpenModalForm] = useState(false);
  const modalToggleExtendCourse = () => setOpenModalForm(!openModalForm);

  const [openModalDetailExtend, setOpenModalDetailExtend] = useState(false);
  const modalToggleDetailExtendCourse = () => setOpenModalDetailExtend(!openModalDetailExtend);

  // toggle ดำเนินการทดสอบ
  const [openModalTestForm, setOpenModalTestForm] = useState(false);
  const modalToggleExtendTest = () => setOpenModalTestForm(!openModalTestForm);

  const [openModalDetailExtendTest, setOpenModalDetailExtendTest] = useState(false);
  const modalToggleDetailExtendTest = () => setOpenModalDetailExtendTest(!openModalDetailExtendTest);

  const [oldCourseData, setOldCourseData] = useState([]);
  const [oldLawOcuuData, setOldOcuuData] = useState([]);


  // ดึงข้อมูลการฝึกอบรม by borrow id 
  useEffect(() => {
    const getCourseByBorrowId = async () => {
      setLoading(true)
      try {
        let res = await fetch(`/api/ExtendAndChangeBorrow/getCourseByBorrowId/${borrowId}`);
        let resJson = await res.json();
        setCourseData(resJson.dataenum);
      } catch (e) {
        // console.log("err =>", e)

      } finally {
        setLoading(false)
      }

    }
    getCourseByBorrowId()

  }, [borrowId])

  // ดึงข้อมูลการดำเนินการทดสอบ by borrow id
  useEffect(() => {
    const getLawOccupationByBorrowId = async () => {
      setLoading(true)
      try {
        let res = await fetch(`/api/ExtendAndChangeBorrow/getLawOccupationByBorrowId/${borrowId}`);
        let resJson = await res.json();
        setLawOcuuByBorrowIdData(resJson.dataenum);
        // console.log("testData", resJson.dataenum);
      } catch (e) {
        // console.log("err =>", e)

      } finally {
        setLoading(false)
      }

    }
    getLawOccupationByBorrowId()
  }, [borrowId])

  useEffect(() => {
    const getBorrowInfo = async () => {
      setLoading(true)
      try {
        let res = await fetch(`/api/ExtendAndChangeBorrow/getInfoByBorrowId/${borrowId}`);
        let resJson = await res.json();
        setBorrowInfo(resJson.dataenum);
        // console.log("borrowInfo", resJson.dataenum);
      } catch (e) {
        // console.log("err =>", e)

      } finally {
        setLoading(false)
      }

    }
    getBorrowInfo()
  }, [borrowId])

  // ดึง master data จังหวัด
  useEffect(() => {
    async function GetProvince() {
      setLoading(true);
      try {
        const responseProvince = await fetch("/api/MasterData/getProvince");
        const localtionData = await responseProvince.json();
        setProvince(localtionData.dataenum);
      } catch (e) {
        // console.log("err => " + e);
      } finally {
        setLoading(false);
      }
    }
    GetProvince()
  }, [])
  const renderCustomHeader = ({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
    // const year = format(date, 'yyyy', { locale: th });
    return (
      <div className="react-datepicker__custom-header">
        <div className="react-datepicker__custom-header-left">
          <button
            type="button"
            className="react-datepicker__navigation react-datepicker__navigation--previous"
            aria-label="previous month"
            onClick={decreaseMonth}
            disabled={prevMonthButtonDisabled}
          >
            <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--previous" />
          </button>
        </div>
        <div className="react-datepicker__custom-header-center">
          {/* {format(date, 'MMMM', { locale: th })} {Number(year) + 543} */}
          <select
            value={thaiMonths[getMonth(date)]}
            onChange={({ target: { value } }) =>
              changeMonth(thaiMonths.indexOf(value))
            }
          >
            {thaiMonths.map(option => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <select
            value={getYear(date)}
            onChange={({ target: { value } }) => changeYear(value)}
          >
            {years.map(option => (
              <option key={option} value={option}>
                {Number(option) + 543}
              </option>
            ))}
          </select>
        </div>
        <div className="react-datepicker__custom-header-right">
          <button
            type="button"
            className="react-datepicker__navigation react-datepicker__navigation--next"
            aria-label="next month"
            onClick={increaseMonth}
            disabled={nextMonthButtonDisabled}
          >
            <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--next" />
          </button>
        </div>
      </div>
    );
  };
  const initialValues = {
    changeCourseDataAr: detailExtendCourseData,
    lawOccupationDataAr: detailExtendLawOccupationData,
    borrowId: borrowId,
    registerId: user.registerId,
  };

  const onSubmit = async (values) => {

    // console.log("values => จ้า",values)

    let postData = new FormData();

    Object.entries(values).forEach(([key, value]) => {
      // postData.append(key, value);
      if (key.slice(-2) === "Ar") {
        postData.append(key, JSON.stringify(value));
      } else {
        postData.append(key, value);
      }
    });

    try {
      setSubmitLoading(true)
      let res = await fetch("api/ExtendAndChangeBorrow/saveExtendCourseOrTest", {
        method: "POST",
        body: postData,
      });

      let resJson = await res.json();

      if (resJson.status === 1) {
        Swal.fire({
          icon: "success",
          title: "บันทึกข้อมูลสำเร็จ",
          text: "โปรดรอเจ้าหน้าที่ตรวจสอบ",
          confirmButtonColor: "#0A66C2",
          confirmButtonText: "ตกลง",
        }).then((result) => {
          if (result.isConfirmed) {
            navigate(`/borrowing/`)
          }
        });

      } else {
        Swal.fire({
          icon: "error",
          title: "บันทึกข้อมูลไม่สำเร็จ",
          text: `เนื่องจาก ${resJson.message}`,
          confirmButtonColor: "#0A66C2",
          confirmButtonText: "ตกลง",
        });
      }
    } catch (e) {
      // console.log(e);
    } finally {
      setSubmitLoading(false);
    }
  };

  const validationSchema = Yup.object().shape({
    // changeCourseDataAr:Yup.array().min(1,"กรุณาเลือกหลักสูตรที่จะเลื่อนฝึกอบรมอย่างน้อย 1 รายการ"),
    // lawOccupationDataAr:Yup.array().min(1,"กรุณาเลือกหลักสูตรที่จะเลื่อนฝึกอบรมอย่างน้อย 1 รายการ")
  });

  const detailChangeCourseInititalValues = {
    id: "",
    extendTime: false,
    changePlace: false,

    trainCourseId: "",
    trainClassId: "",
    oldCourseName: "",
    oldClassId: "",
    newStartDate: "",
    newEndDate: "",

    newLocationName: "",
    newAddressNo: "",
    newMoo: "",
    newSoi: "",
    newStreet: "",
    newProvinceCode: "",
    newAmphurCode: "",
    newTumbonCode: "",
    newPostCode: "",
    newPhone: "",
    newFax: "",
    newMobile: "",
    newEmail: "",
    // newFLocationPath:"",

    locationId: "",
  };

  const detailChangeCourseOnsubmit = (values, actions) => {
    // console.log(values.id);
    // console.log(values.newFLocationPath)

    if (values.id !== "") {
      setDetailExtendCourseData((old) =>
        old.map((row) => {
          if (row.id === values.id) {
            return {
              ...values,
              id: values.id,
            };
          }
          return row;
        })
      );
      modalToggleDetailExtendCourse(!openModalDetailExtend);
    } else {
      let pre = {
        ...values,
        id: uuidv4(),
      };
      // console.log(pre)
      setDetailExtendCourseData((prev) => [...prev, pre]);
      actions.resetForm();
      modalToggleDetailExtendCourse(!openModalDetailExtend);
      modalToggleExtendCourse(!modalToggleExtendCourse);
    }
  };

  const detailChangeCourseValidateSchema = Yup.object().shape({
    newFLocationPath: Yup.mixed()
  });

  const courseDataInitialValues = {
    checkDuplicateValue: "",
    trainCourseId: "",
    trainClassId: ""
  }

  const courseDataValidateSchema = Yup.object().shape({
    trainCourseId: Yup.string().required("กรุณาเลือกหลักสูตร"),
    trainClassId: Yup.string().required("กรุณาเลือกรุ่น")
  })

  const handleSubmitCourseData = async (values, { setFieldError, setFieldTouched }) => {
    // console.log(setFieldTouched)
    // console.log(values)
    const { trainCourseId, trainClassId } = values;

    if (trainCourseId === "--กรุณาเลือกหลักสูตร--" || trainClassId === "--กรุณาเลือกรุ่น--") {
      return;

    } else {
      let match;
      detailExtendCourseData.map((item) => (
        match = item.hasOwnProperty('trainCourseId') && item.hasOwnProperty('trainClassId') && item.trainCourseId === Number(trainCourseId) && item.trainClassId === Number(trainClassId)
      ))
      // console.log(match)

      if (match) {
        setFieldError("checkDuplicateValue", "หลักสูตรการฝึกอบรม และ รุ่น ได้ถูกเลือกไปแล้ว")
        setFieldTouched && setFieldError('trainCourseId', true);
        setFieldTouched && setFieldError('trainClassId', true);
      } else {
        try {
          let res = await fetch("api/ExtendAndChangeBorrow/getOldCourseAndClass", {
            method: "POST",
            headers: { "Content-type": "application/json" },
            body: JSON.stringify(values)
          })
          let resJson = await res.json();
          // console.log(resJson.dataenum)
          setOldCourseData(resJson.dataenum)
        } catch (e) {
          // console.log(e)
        } finally {
          modalToggleDetailExtendCourse(!modalToggleDetailExtendCourse)
        }
      }
    }
  }

  async function courseDetailOnEdit(row) {
    // console.log("row =>", row);
    try {
      let res = await fetch("api/ExtendAndChangeBorrow/getOldCourseAndClass", {
        method: "POST",
        headers: { "Content-type": "application/json" },
        body: JSON.stringify(row)
      })
      let resJson = await res.json();
      // console.log(resJson.dataenum)
      setOldCourseData(resJson.dataenum)
      GetAmphurForEdit(row.newProvinceCode);
      GetTumbonForEdit(row.newProvinceCode, row.newAmphurCode);
    } catch (e) {
      // console.log(e)
    } finally {
      setIsEditing(true)
      setSelectedItem(row)
      // console.log(isEditing)
      // console.log(selectedItem)
      modalToggleDetailExtendCourse(!openModalDetailExtend);

    }
  }

  function courseDetailOnDelete(row) {
    setDetailExtendCourseData((current) =>
      current.filter((obj) => {
        return obj.id !== row.id;
      })
    );
  }

  async function testDetailOnEdit(row) {
    // console.log("row =>", row);
    try {
      let res = await fetch("api/ExtendAndChangeBorrow/testTimeDetailByBorrowId", {
        method: "POST",
        headers: { "Content-type": "application/json" },
        body: JSON.stringify(row)
      })
      let resJson = await res.json();
      // console.log(resJson.dataenum)
      setOldOcuuData(resJson.dataenum)
    } catch (e) {
      // console.log(e)
    } finally {

      setIsTestEditing(true)
      setSelectedTestItem(row)
      modalToggleDetailExtendTest(!openModalDetailExtendTest)

    }
  }

  function testDetailOnDelete(row) {
    setDetailExtendLawOccupationData((current) =>
      current.filter((obj) => {
        return obj.id !== row.id;
      })
    );
  }




  async function GetAmphurForEdit(provinceCode) {
    let postData = new FormData();
    postData.append("provinceCode", provinceCode);

    try {
      const responseAmphur = await fetch("/api/MasterData/getAmphur", {
        method: "POST",
        body: postData,
      });
      const amphurData = await responseAmphur.json();
      setAmphur(amphurData.dataenum);
    } catch (err) {
      // console.log("err =>" + err);
    }
  }

  // ดึง master data ตำบล ที่อยู่ปัจจุบันที่ติดต่อได้
  async function GetTumbonForEdit(provinceCode, amphurCode) {

    let postData = new FormData();
    postData.append("provinceCode", provinceCode);
    postData.append("amphurCode", amphurCode);
    try {
      let responseTumbon = await fetch("/api/MasterData/getTumbon", {
        method: "POST",
        body: postData,
      });
      const tumbonData = await responseTumbon.json();
      setTumbon(tumbonData.dataenum);
    } catch (err) {
      // console.log("err =>" + err);
    }
  }

  const COLUMNS = [
    {
      Header: "ลำดับ",
      accessor: (_row, i) => i + 1,
    },
    {
      Header: "หลักสูตรของคุณ",
      accessor: "oldCourseName",
    },
    {
      Header: "รุ่นที่",
      accessor: "oldClassId",
    },
    {
      Header: "รายละเอียด",
      accessor: "id",
      Cell: ({ row, value }) => {
        return (
          <div className="text-center">
            <button
              type="button"
              className="btn border border-1 mx-1"
              onClick={() =>
                courseDetailOnEdit(row.original)
              }
            >
              แก้ไข
            </button>
            <button
              type="button"
              className="btn border border-1 mx-1"
              onClick={() =>
                courseDetailOnDelete(row.original)
              }
            >
              ลบ
            </button>
          </div>
        );
      },
    },
  ];

  const COLUMNSTEST = [
    {
      Header: "ลำดับ",
      accessor: (_row, i) => i + 1,
    },
    {
      Header: "สาขาอาชีพของคุณ",
      accessor: "oldlawOcuupationName",
    },
    {
      Header: "ครั้งที่",
      accessor: "oldTime",
    },
    {
      Header: "รายละเอียด",
      accessor: "id",
      Cell: ({ row, value }) => {
        return (
          <div className="text-center">
            <button
              type="button"
              className="btn border border-1 mx-1"
              onClick={() =>
                testDetailOnEdit(row.original)
              }
            >
              แก้ไข
            </button>
            <button
              type="button"
              className="btn border border-1 mx-1"
              onClick={() =>
                testDetailOnDelete(row.original)
              }
            >
              ลบ
            </button>
          </div>
        );
      },
    },
  ];

  const lawOcuuDataInitialValues = {
    checkDuplicateTestValue: "",
    testId: "",
    testTimeId: ""
  };

  const handleSubmitLawOcuuData = async (values, { setFieldError, setFieldTouched }) => {
    // console.log(setFieldTouched)
    // console.log(values)
    const { testId, testTimeId } = values;

    if (testId === "--กรุณาเลือกสาขาอาชีพ--" || testTimeId === "--กรุณาเลือกครั้งที่ดำเนินการทดสอบ--") {
      return;

    } else {
      let match;
      detailExtendLawOccupationData.map((item) => (
        match = item.hasOwnProperty('testId') && item.hasOwnProperty('testTimeId') && item.testId === Number(testId) && item.testTimeId === Number(testTimeId)
      ))
      // console.log(match)

      if (match) {
        setFieldError("checkDuplicateTestValue", "สาขาอาชีพและครั้งที่นี้ ได้ถูกเลือกไปแล้ว")
        setFieldTouched && setFieldError('testId', true);
        setFieldTouched && setFieldError('testTimeId', true);
      } else {
        try {
          let res = await fetch("api/ExtendAndChangeBorrow/testTimeDetailByBorrowId", {
            method: "POST",
            headers: { "Content-type": "application/json" },
            body: JSON.stringify(values)
          })
          let resJson = await res.json();
          // console.log("OldOcuuData", resJson.dataenum)
          setOldOcuuData(resJson.dataenum)
        } catch (e) {
          // console.log(e)
        } finally {
          modalToggleDetailExtendTest(!openModalDetailExtendTest)
        }
      }
    }
  };

  const detailChangeTestInititalValues = {
    id: "",
    extendTestTime: false,
    changeTestPlace: false,

    testId: "",
    testTimeId: "",
    oldLawOcuupationName: "",
    oldTime: "",
    newStartDate: "",
    newEndDate: "",

    newLocationName: "",
    newAddressNo: "",
    newMoo: "",
    newSoi: "",
    newStreet: "",
    newProvinceCode: "",
    newAmphurCode: "",
    newTumbonCode: "",
    newPostCode: "",
    newPhone: "",
    newFax: "",
    newMobile: "",
    newEmail: "",
    newTestFLocationPath: "",
    locationId: "",
  }

  const detailChangelawOcuuOnsubmit = (values, actions) => {
    // console.log("value of detailChangeLawOcuu",values)
    // console.log(values.id);

    if (values.id !== "") {
      setDetailExtendLawOccupationData((old) =>
        old.map((row) => {
          if (row.id === values.id) {
            return {
              ...values,
              id: values.id,
            };
          }
          return row;
        })
      );
      modalToggleDetailExtendTest(!openModalDetailExtendTest);
    } else {
      let pre = {
        ...values,
        id: uuidv4(),
      };
      // console.log(pre)
      setDetailExtendLawOccupationData((prev) => [...prev, pre]);
      actions.resetForm();
      modalToggleDetailExtendTest(!openModalDetailExtendTest);
      modalToggleExtendTest(!modalToggleExtendTest);
    }
  };

  const detailChangelawOcuuValidateSchema = Yup.object().shape({
    testId: Yup.string().required("กรุณาเลือกสาขาอาชีพ"),
    testTimeId: Yup.string().required("กรุณาเลือกครั้งที่ดำเนินการทดสอบ")
  });


  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {({ setFieldValue, values, touched, errors, isValid, dirty, handleBlur, handleChange }) => {
        // console.log("errors",errors)

        const getClassId = async (e) => {
          if (e.target.value !== "--กรุณาเลือกหลักสูตร--") {
            let postData = new FormData();
            postData.append("trainCourseId", e.target.value);
            try {
              let res = await fetch("api/ExtendAndChangeBorrow/getClassId", {
                method: "POST",
                body: postData
              })
              let resJson = await res.json();
              setClassData(resJson.dataenum);
            } catch (e) {
              // console.log("err => ", e)
            }
          } else {
            return;
          }
        }

        const getTestTimeId = async (e) => {
          // console.log(e.target.value)
          if (e.target.value !== "--กรุณาเลือกสาขาอาชีพ--") {
            let postData = new FormData();
            postData.append("testId", e.target.value);
            try {
              let res = await fetch("api/ExtendAndChangeBorrow/getTestTimeByBorrowId", {
                method: "POST",
                body: postData
              })
              let resJson = await res.json();
              setTestTimeData(resJson.dataenum);
              // console.log("testtimeData", resJson.dataenum)
            } catch (e) {
              // console.log("err => ", e)
            }
          } else {
            return;
          }
        }

        return (
          <Container className="d-flex flex-column justify-content-center align-items-center mb-5">
            {!loading ? (
              <div className="form-border">
                <Form className="p-5 mb-4">
                  {borrowInfo.map(data => (
                    <>
                      <FormGroup>
                        <Label>
                          เลขที่สัญญา
                        </Label>
                        <span className="input-color mx-2">
                          {data.contactNumber}
                        </span>
                      </FormGroup>
                      <FormGroup>
                        <Label>
                          ชื่อผู้กู้ยืม
                        </Label>
                        <span className="input-color mx-2">
                          {data.employee}
                        </span>
                      </FormGroup>
                    </>
                  ))}

                  <ErrorMessage name="changeCourseDataAr">{msg => <div className="text-danger">{msg}</div>}</ErrorMessage>
                  <ErrorMessage name="changeCourseDataAr">{msg => <div className="text-danger">{msg}</div>}</ErrorMessage>

                  {courseData.length ?
                    <>
                      <Formik
                        initialValues={courseDataInitialValues}
                        validationSchema={courseDataValidateSchema}
                        onSubmit={handleSubmitCourseData}
                        enableReinitialize
                      >{({ values, handleChange, handleBlur, setFieldValue, setValues, resetForm, errors, touched }) => {

                        const onAddCourseDetail = () => {
                          setIsEditing(false);
                          resetForm()
                          modalToggleExtendCourse();
                        };

                        const AddDetailCourseBtn = () => {
                          return (
                            <button
                              className="btn border border-1 text-white btn-green"
                              // style={{backgroundColor:"#0A66C2"}}
                              onClick={() => onAddCourseDetail()}
                            >
                              <BsPlusLg className="mx-2" />
                              แจ้งเลื่อนการฝึกอบรม
                            </button>
                          );
                        };
                        return (
                          <div className="">

                            <CreateTableComponent
                              column={COLUMNS}
                              dataInput={detailExtendCourseData}
                              FormInput={AddDetailCourseBtn}
                              showEntrie={false}
                              showPage={false}
                            />

                            <Modal
                              isOpen={openModalForm}
                              toggle={modalToggleExtendCourse}
                              style={{ maxWidth: "600px", width: "100%" }}
                              centered
                              // scrollable
                              className="modal-bordered"
                              backdrop={"static"}
                              keyboard={false}
                            >
                              <ModalHeader className="styled-modal text-center" toggle={modalToggleExtendCourse}>
                                เลือกหลักสูตรและรุ่นที่ต้องการ
                              </ModalHeader>
                              <ModalBody className="form-border">
                                <div style={{ maxWidth: "600px", width: "100%" }}>
                                  <Form autoComplete="off" className="">
                                    <div className="p-4">
                                      <FormGroup>
                                        <div>

                                          <Label>หลักสูตรการฝึกอบรม</Label>
                                          {touched.trainCourseId && errors.trainCourseId ? (
                                            <span className="text-left text-danger px-1">
                                              {errors.trainCourseId}
                                            </span>
                                          ) : null}
                                          <Field name="trainCourseId">
                                            {({ field, meta }) => (
                                              <Input
                                                type="select"
                                                className={meta.touched && meta.error ? "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"}
                                                {...field}
                                                onChange={(e) => {
                                                  handleChange(e)
                                                  setFieldValue("trainClassId", "--กรุณาเลือกรุ่น--")
                                                  getClassId(e)
                                                }}
                                              >
                                                <option defaultValue={"--กรุณาเลือกหลักสูตร--"}>
                                                  --กรุณาเลือกหลักสูตร--
                                                </option>
                                                {courseData.map((course, i) => (
                                                  <option
                                                    key={i}
                                                    value={course.trainCourseId}
                                                  >
                                                    {course.courseName}
                                                  </option>
                                                ))}
                                              </Input>
                                            )}
                                          </Field>
                                        </div>
                                        <div>
                                          <Label className="mt-2">รุ่น</Label>
                                          {touched.trainClassId && errors.trainClassId ? (
                                            <span className="text-left text-danger px-1">
                                              {errors.trainClassId}
                                            </span>
                                          ) : null}
                                          <Field name="trainClassId">
                                            {({ field, meta }) => (
                                              <Input
                                                type="select"
                                                className={meta.touched && meta.error ? "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"}
                                                {...field}
                                                onChange={(e) => {
                                                  handleChange(e)
                                                }}
                                              >
                                                <option defaultValue={"--กรุณาเลือกรุ่น--"}>
                                                  --กรุณาเลือกรุ่น--
                                                </option>
                                                {classData.map((data, i) => (
                                                  <option
                                                    key={i}
                                                    value={data.trainClassId}
                                                  >
                                                    รุ่นที่ {data.class}
                                                  </option>
                                                ))}
                                              </Input>
                                            )}
                                          </Field>
                                          <ErrorMessage name="checkDuplicateValue" component={TextErrors} />
                                        </div>
                                      </FormGroup>
                                    </div>
                                    <ModalFooter className="d-flex justify-content-center">
                                      <button
                                        type="submit"
                                        className="btn-blue w-50"
                                      >
                                        กรอกข้อมูล
                                      </button>
                                    </ModalFooter>
                                  </Form>
                                </div>
                              </ModalBody>
                            </Modal>
                          </div>
                        );
                      }}
                      </Formik>

                      <Formik
                        initialValues={isEditing ? selectedItem : detailChangeCourseInititalValues}
                        validationSchema={detailChangeCourseValidateSchema}
                        onSubmit={detailChangeCourseOnsubmit}
                        enableReinitialize
                      >{({ values, handleChange, handleBlur, setFieldValue, setValues, resetForm, errors, touched }) => {
                        // console.log(values)

                        async function GetAmphur(e) {
                          let postData = new FormData();
                          postData.append("provinceCode", e.target.value);

                          try {
                            const responseAmphur = await fetch("/api/MasterData/getAmphur", {
                              method: "POST",
                              body: postData,
                            });
                            const amphurData = await responseAmphur.json();
                            setAmphur(amphurData.dataenum);
                          } catch (err) {
                            // console.log("err =>" + err);
                          }
                        }

                        // ดึง master data ตำบล ที่อยู่ปัจจุบันที่ติดต่อได้
                        async function GetTumbon(e) {

                          let postData = new FormData();
                          postData.append("provinceCode", values.newProvinceCode);
                          postData.append("amphurCode", e.target.value);
                          try {
                            let responseTumbon = await fetch("/api/MasterData/getTumbon", {
                              method: "POST",
                              body: postData,
                            });
                            const tumbonData = await responseTumbon.json();
                            setTumbon(tumbonData.dataenum);
                          } catch (err) {
                            // console.log("err =>" + err);
                          }
                        }

                        // หา location_id ที่อยู่ปัจจุบันที่ติดต่อได้
                        async function GetLocationsId(e) {

                          let postData = new FormData();
                          postData.append("provinceCode", values.newProvinceCode);
                          postData.append("amphurCode", values.newAmphurCode);
                          postData.append("tumbonCode", e.target.value);
                          try {
                            let res = await fetch("/api/MasterData/getLocationId", {
                              method: "POST",
                              body: postData,
                            });
                            const locationId = await res.json();

                            let setLocationId = locationId.dataenum
                              .map(({ locationId }) => locationId)
                              .join()
                              .toString();
                            setFieldValue("locationId", setLocationId);
                            // console.log(setLocationId);
                          } catch (err) {
                            // console.log("err =>" + err);
                          }
                        }

                        return (
                          <Modal
                            isOpen={openModalDetailExtend}
                            toggle={modalToggleDetailExtendCourse}
                            size="xl"
                            // style={{ maxWidth: "960px", width: "100%" }}
                            // className="modal-bordered"
                            backdrop={"static"}
                            keyboard={false}
                          >
                            <ModalHeader className="text-center" toggle={modalToggleDetailExtendCourse}>
                              รายละเอียดการแจ้งเลื่อนการฝึกอบรม
                            </ModalHeader>
                            <ModalBody className="">
                              <div>
                                <Form
                                  autoComplete="off"
                                  className="p-4"
                                >
                                  {/* ข้อมูลเดิม */}
                                  {oldCourseData.map((item, k) => (
                                    <>
                                      <Field
                                        name={`id`}
                                        type="text"
                                        style={{ display: "none" }}
                                        disabled={true}
                                      />
                                      <Field
                                        name={`trainCourseId`}
                                        style={{ display: "none" }}
                                        type="text"
                                        disabled={true}

                                      />
                                      <Field
                                        name={`trainClassId`}
                                        style={{ display: "none" }}
                                        type="text"
                                        disabled={true}
                                      />
                                      <Field
                                        name={`oldCourseName`}
                                        style={{ display: "none" }}
                                        type="text"
                                        disabled={true}
                                      />
                                      <Field
                                        name={`oldClassId`}
                                        style={{ display: "none" }}
                                        type="text"
                                        disabled={true}
                                      />

                                      <div style={{ lineHeight: "2rem" }}>
                                        <p className="text-white bg bg-primary text-center">ข้อมูลเดิม</p>
                                      </div>
                                      {/* ข้อมูลเดิม */}
                                      <div className="border border-1 mx-2">
                                        <FormGroup className="px-2 mt-3">
                                          <Label>ชื่อหลักสูตร :</Label>
                                          <span className="mx-1 input-color">{item.courseName}</span>
                                          <Label>รุ่นที่ :</Label>
                                          <span className="mx-1 input-color">{item.classId}</span>
                                          <Label>วันที่เริ่มฝึกอบรม :</Label>
                                          <span className="mx-1 input-color">{item.startDate}</span>
                                          <Label>วันที่สิ้นสุดการฝึกอบรม :</Label>
                                          <span className="mx-1 input-color">{item.endDate}</span>
                                        </FormGroup>
                                        <div>
                                          <Label className="px-2">สถานที่ฝึกอบรม</Label>
                                          <FormGroup className="px-2">
                                            <Label>เลขที่</Label>
                                            <span className="mx-1 input-color">{item.addressNo}</span>
                                            <Label>หมู่ที่:</Label>
                                            {item.moo ? <span className="mx-1 input-color">{item.moo}</span> : <span className="mx-1 input-color">-</span>}
                                            <Label>ซอย:</Label>
                                            {item.soi ? <span className="mx-1 input-color">{item.soi}</span> : <span className="mx-1 input-color">-</span>}
                                            <Label>ถนน:</Label>
                                            {item.street ? <span className="mx-1 input-color">{item.street}</span> : <span className="mx-1 input-color">-</span>}
                                            <Label>ตำบล:</Label>
                                            {item.tumbonName ? <span className="mx-1 input-color">{item.tumbonName}</span> : <span className="mx-1 input-color">-</span>}
                                            <Label>อำเภอ:</Label>
                                            {item.amphurName ? <span className="mx-1 input-color">{item.amphurName}</span> : <span className="mx-1 input-color">-</span>}
                                            <Label>จังหวัด:</Label>
                                            {item.provinceName ? <span className="mx-1 input-color">{item.provinceName}</span> : <span className="mx-1 input-color">-</span>}
                                            <Label>รหัสไปรษณีย์:</Label>
                                            {item.postCode ? <span className="mx-1 input-color">{item.postCode}</span> : <span className="mx-1 input-color">-</span>}
                                          </FormGroup>
                                        </div>

                                      </div>
                                      <div className="mt-3" style={{ lineHeight: "2rem" }}>
                                        <p className="text-white bg bg-primary text-center">ข้อมูลใหม่</p>
                                      </div>
                                      <Label
                                        for=""
                                      >
                                        เลื่อนระยะเวลาการฝึกอบรม
                                      </Label>
                                      <Input
                                        className="cus-type mx-2"
                                        type="checkbox"
                                        name="extendTime"
                                        onChange={(e) => {
                                          handleChange(e)
                                          setFieldValue("trainCourseId", item.trainCourseId)
                                          setFieldValue("trainClassId", item.trainClassId)
                                          setFieldValue("oldCourseName", item.courseName)
                                          setFieldValue("oldClassId", item.classId)

                                        }}
                                        onBlur={handleBlur}
                                        value={values.extendTime}
                                        checked={values.extendTime}
                                      />
                                      <FormGroup row>
                                        <Label for="" sm={1}>
                                          วันที่
                                        </Label>
                                        <Col sm={5}>
                                          <Field name="newStartDate">
                                            {({ field, meta, form }) => {
                                              const selectedDate = field.value ? new Date(field.value) : null; // check if field.value is not null or undefined
                                              // console.log("select Data =>", selectedDate)
                                              const selectedDateInBE = selectedDate ? addYears(543, selectedDate) : null; // convert to Thai Buddhist
                                              const monthInThai = selectedDateInBE ? format(selectedDateInBE, 'MMMM', { locale: th }) : null;
                                              const formattedDate = selectedDateInBE ? format(selectedDateInBE, 'dd') + ' ' + monthInThai + ' ' + format(selectedDateInBE, 'yyyy') : null;


                                              return (
                                                <DatePicker
                                                  selected={selectedDate}
                                                  locale="th-buddhist"
                                                  showIcon
                                                  calendarClassName="thai-buddhist"
                                                  dateFormat="dd MMMM yyyy"
                                                  value={formattedDate}
                                                  disabled={values.extendTime === false}
                                                  isClearable={true}
                                                  placeholderText="กรุณาเลือก"
                                                  renderCustomHeader={renderCustomHeader}
                                                  onChange={(date) => {
                                                    if (date instanceof Date && !isNaN(date)) {
                                                      const year = date.getFullYear();
                                                      const month = String(date.getMonth() + 1).padStart(2, '0');
                                                      const day = String(date.getDate()).padStart(2, '0');
                                                      const formattedDate = `${year}-${month}-${day}`;
                                                      // console.log("format", typeof (formattedDate))
                                                      form.setFieldValue(field.name, formattedDate);
                                                    } else {
                                                      form.setFieldValue(field.name, "");
                                                    }
                                                  }}
                                                  customInput={
                                                    <Input
                                                      type="text"

                                                      className={
                                                        touched.cardExpireDate && errors.cardExpireDate
                                                          ? "input-error rounded-pill text-center input-color"
                                                          : "rounded-pill text-center input-color"
                                                      }
                                                      value={formattedDate}
                                                      onChange={() => { }}
                                                      onBlur={field.onBlur}
                                                    />
                                                  }
                                                />
                                              )
                                            }}
                                          </Field>

                                        </Col>
                                        <Label for="" sm={1}>
                                          ถึง
                                        </Label>
                                        <Col sm={5}>
                                          <Field name="newEndDate">
                                            {({ field, meta, form }) => {
                                              const selectedDate = field.value ? new Date(field.value) : null; // check if field.value is not null or undefined
                                              // console.log("select Data =>", selectedDate)
                                              const selectedDateInBE = selectedDate ? addYears(543, selectedDate) : null; // convert to Thai Buddhist
                                              const monthInThai = selectedDateInBE ? format(selectedDateInBE, 'MMMM', { locale: th }) : null;
                                              const formattedDate = selectedDateInBE ? format(selectedDateInBE, 'dd') + ' ' + monthInThai + ' ' + format(selectedDateInBE, 'yyyy') : null;


                                              return (
                                                <DatePicker
                                                  selected={selectedDate}
                                                  locale="th-buddhist"
                                                  showIcon
                                                  calendarClassName="thai-buddhist"
                                                  dateFormat="dd MMMM yyyy"
                                                  value={formattedDate}
                                                  disabled={values.extendTime === false}
                                                  isClearable={true}
                                                  placeholderText="กรุณาเลือก"
                                                  renderCustomHeader={renderCustomHeader}
                                                  onChange={(date) => {
                                                    if (date instanceof Date && !isNaN(date)) {
                                                      const year = date.getFullYear();
                                                      const month = String(date.getMonth() + 1).padStart(2, '0');
                                                      const day = String(date.getDate()).padStart(2, '0');
                                                      const formattedDate = `${year}-${month}-${day}`;
                                                      // console.log("format", typeof (formattedDate))
                                                      form.setFieldValue(field.name, formattedDate);
                                                    } else {
                                                      form.setFieldValue(field.name, "");
                                                    }
                                                  }}
                                                  customInput={
                                                    <Input
                                                      type="text"

                                                      className={
                                                        touched.cardExpireDate && errors.cardExpireDate
                                                          ? "input-error rounded-pill text-center input-color"
                                                          : "rounded-pill text-center input-color"
                                                      }
                                                      value={formattedDate}
                                                      onChange={() => { }}
                                                      onBlur={field.onBlur}
                                                    />
                                                  }
                                                />
                                              )
                                            }}
                                          </Field>
                                          {/* <Field
                                                  name={`newEndDate`}
                                                >
                                                  {({ field, form }) => (
                                                    
                                                    <Input
                                                      type="date"
                                                      disabled={values.extendTime === false}
                                                      className="rounded-pill text-center input-color mx-3 "
                                                      {...field}
                                                    />
                                                  )}
                                                </Field> */}
                                        </Col>
                                      </FormGroup>
                                      <Label
                                        for=""
                                      >
                                        เปลี่ยนแปลงสถานที่ฝึกอบรม
                                      </Label>
                                      <Input
                                        className="cus-type mx-2"
                                        type="checkbox"
                                        name="changePlace"
                                        onChange={(e) => {
                                          handleChange(e)
                                          setFieldValue("trainCourseId", item.trainCourseId)
                                          setFieldValue("trainClassId", item.trainClassId)
                                          setFieldValue("oldCourseName", item.courseName)
                                          setFieldValue("oldClassId", item.classId)
                                        }}
                                        onBlur={handleBlur}
                                        value={values.changePlace}
                                        checked={values.changePlace}
                                      />


                                      <FormGroup row className="mt-2">

                                        <Label for="" sm={3}>
                                          ชื่อสถานที่ฝึกอบรม
                                          <span className="require-input">*</span>
                                        </Label>
                                        <Col sm={9}>
                                          <Field
                                            name={`newLocationName`}
                                          >
                                            {({ field, meta }) => (
                                              <Input
                                                disabled={values.changePlace === false}
                                                type="text"
                                                className="rounded-pill text-left input-color"
                                                {...field}
                                              />
                                            )}
                                          </Field>
                                        </Col>
                                      </FormGroup>
                                      <FormGroup row>
                                        <Label for="" sm={2}>
                                          เลขที่
                                          <span className="require-input">*</span>
                                        </Label>
                                        <Col sm={4}>
                                          <Field
                                            name={`newAddressNo`}
                                          >
                                            {({ field, meta }) => (
                                              <Input
                                                disabled={values.changePlace === false}
                                                type="text"
                                                className="rounded-pill text-left input-color"
                                                {...field}
                                              />
                                            )}
                                          </Field>
                                        </Col>

                                        <Label for="moo" sm={2}>
                                          หมู่ที่

                                        </Label>
                                        <Col sm={4}>
                                          <Field
                                            name={`newMoo`}
                                          >
                                            {({ field, meta }) => (
                                              <Input
                                                disabled={values.changePlace === false}
                                                type="text"
                                                className="rounded-pill text-left input-color"
                                                {...field}
                                              />
                                            )}
                                          </Field>
                                        </Col>
                                      </FormGroup>
                                      <FormGroup row>
                                        <Label for="soi" sm={2}>
                                          ซอย
                                        </Label>
                                        <Col sm={4}>
                                          <Field
                                            name={`newSoi`}
                                          >
                                            {({ field, meta }) => (
                                              <Input
                                                disabled={values.changePlace === false}
                                                type="text"
                                                className="rounded-pill text-left input-color"
                                                {...field}
                                              />
                                            )}
                                          </Field>
                                        </Col>

                                        <Label for="street" sm={2}>
                                          ถนน
                                        </Label>
                                        <Col sm={4}>
                                          <Field
                                            name={`newStreet`}
                                          >
                                            {({ field, meta }) => (
                                              <Input
                                                disabled={values.changePlace === false}
                                                type="text"
                                                className="rounded-pill text-left input-color"
                                                {...field}
                                              />
                                            )}
                                          </Field>
                                        </Col>
                                      </FormGroup>

                                      <FormGroup row>
                                        <Label for="" sm={2}>
                                          จังหวัด
                                          <span className="require-input">*</span>
                                        </Label>
                                        <Col sm={4}>
                                          <Field
                                            name={`newProvinceCode`}
                                          >
                                            {({ field, form, meta }) => (
                                              <Input
                                                disabled={values.changePlace === false}
                                                type="select"
                                                className="rounded-pill text-center input-color"
                                                {...field}
                                                onChange={(e) => {
                                                  handleChange(e);
                                                  GetAmphur(e);
                                                }}
                                              >
                                                <option
                                                  defaultValue={"กรุณาเลือกจังหวัด"}
                                                >
                                                  กรุณาเลือกจังหวัด
                                                </option>
                                                {province.map((p) => (
                                                  <option
                                                    key={p.provinceCode}
                                                    value={String(
                                                      p.provinceCode
                                                    )}
                                                  >
                                                    {p.provinceName}
                                                  </option>
                                                ))}
                                              </Input>
                                            )}
                                          </Field>
                                        </Col>

                                        <Label for="" sm={2}>
                                          อำเภอ/เขต
                                          <span className="require-input">*</span>
                                        </Label>
                                        <Col sm={4}>
                                          <Field
                                            name={`newAmphurCode`}
                                          >
                                            {({ field, form, meta }) => (
                                              <Input
                                                disabled={values.changePlace === false}
                                                type="select"
                                                className="rounded-pill text-center input-color"
                                                {...field}
                                                onChange={(e) => {
                                                  handleChange(e);
                                                  GetTumbon(e);
                                                }}
                                              >
                                                <option
                                                  defaultValue={
                                                    "กรุณาเลือกอำเภอ/เขต"
                                                  }
                                                >
                                                  กรุณาเลือกอำเภอ/เขต
                                                </option>
                                                {amphur.map((a) => (
                                                  <option
                                                    key={a.amphurCode}
                                                    value={String(
                                                      a.amphurCode
                                                    )}
                                                  >
                                                    {a.amphurName}
                                                  </option>
                                                ))}
                                              </Input>
                                            )}
                                          </Field>
                                        </Col>
                                      </FormGroup>
                                      <FormGroup row>
                                        <Label sm={2}>
                                          ตำบล/แขวง
                                          <span className="require-input">*</span>
                                        </Label>
                                        <Col sm={4}>
                                          <Field
                                            name={`newTumbonCode`}
                                          >
                                            {({ field, meta }) => (
                                              <Input
                                                disabled={values.changePlace === false}
                                                type="select"
                                                className="rounded-pill text-center input-color"
                                                {...field}
                                                onChange={(e) => {
                                                  handleChange(e);
                                                  GetLocationsId(e);
                                                }}
                                              >
                                                <option
                                                  defaultValue={
                                                    "กรุณาเลือกตำบล/แขวง"
                                                  }
                                                >
                                                  กรุณาเลือกตำบล/แขวง
                                                </option>
                                                {tumbon.map((t) => (
                                                  <option
                                                    key={t.tumbonCode}
                                                    value={String(
                                                      t.tumbonCode
                                                    )}
                                                  >
                                                    {t.tumbonName}
                                                  </option>
                                                ))}
                                              </Input>
                                            )}
                                          </Field>
                                          <Field
                                            name={`locationId`}
                                            style={{ display: "none" }}
                                          />
                                        </Col>

                                        <Label for="postCode" sm={2}>
                                          รหัสไปรษณีย์
                                          <span className="require-input">*</span>
                                        </Label>
                                        <Col sm={4}>
                                          <Field
                                            name={`newPostCode`}
                                          >
                                            {({ field, meta }) => (
                                              <Input
                                                disabled={values.changePlace === false}
                                                type="text"
                                                className="rounded-pill text-center input-color"
                                                {...field}
                                              />
                                            )}
                                          </Field>
                                        </Col>
                                      </FormGroup>
                                      <FormGroup row>
                                        <Label for="" sm={2}>
                                          โทรศัพท์
                                          <span className="require-input">*</span>
                                        </Label>
                                        <Col sm={4}>
                                          <Field
                                            name={`newPhone`}
                                          >
                                            {({ field, meta }) => (
                                              <Input
                                                disabled={values.changePlace === false}
                                                type="text"
                                                className="rounded-pill text-center input-color"
                                                {...field}
                                              />
                                            )}
                                          </Field>
                                        </Col>

                                        <Label for="" sm={2}>
                                          โทรสาร
                                        </Label>
                                        <Col sm={4}>
                                          <Field
                                            name={`newFax`}
                                          >
                                            {({ field, meta }) => (
                                              <Input
                                                disabled={values.changePlace === false}
                                                type="text"
                                                className="rounded-pill text-center input-color"
                                                {...field}
                                              />
                                            )}
                                          </Field>
                                        </Col>
                                      </FormGroup>
                                      <FormGroup row>
                                        <Label for="" sm={2}>
                                          โทรศัพท์มือถือ
                                          <span className="require-input">*</span>
                                        </Label>
                                        <Col sm={4}>
                                          <Field
                                            name={`newMobile`}
                                          >
                                            {({ field, meta }) => (
                                              <Input
                                                disabled={values.changePlace === false}
                                                type="text"
                                                className="rounded-pill text-center input-color"
                                                {...field}
                                              />
                                            )}
                                          </Field>
                                        </Col>

                                        <Label for="email" sm={2}>
                                          อีเมล
                                          <span className="require-input">*</span>
                                        </Label>
                                        <Col sm={4}>
                                          <Field
                                            name={`newEmail`}
                                          >
                                            {({ field, meta }) => (
                                              <Input
                                                disabled={values.changePlace === false}
                                                type="text"
                                                className="rounded-pill text-center input-color"
                                                {...field}
                                              />
                                            )}
                                          </Field>
                                        </Col>
                                      </FormGroup>

                                      <div className="d-flex justify-content-center align-items-center pt-4">
                                        <button type="submit" className="btn border border-1 mx-1">ยืนยัน</button>
                                        <button type="button" className="btn border border-1 mx-1">ยกเลิก</button>
                                      </div>

                                    </>
                                  ))}
                                </Form>
                              </div>
                            </ModalBody>
                          </Modal>
                        )
                      }}

                      </Formik>
                    </> : null}

                  {lawOcuuByBorrowIdData.length ?
                    <>
                      <Formik
                        initialValues={lawOcuuDataInitialValues}
                        validationSchema={detailChangelawOcuuValidateSchema}
                        onSubmit={handleSubmitLawOcuuData}
                        enableReinitialize
                      >{({ values, handleChange, handleBlur, setFieldValue, setValues, resetForm, errors, touched }) => {

                        const onAddTestDetail = () => {
                          setSelectedTestItem(null)
                          setIsTestEditing(false);
                          resetForm()
                          modalToggleExtendTest();
                        };

                        const AddDetailTestBtn = () => {
                          return (
                            <button
                              className="btn border border-1 text-white btn-green"
                              // style={{backgroundColor:"#0A66C2"}}
                              onClick={() => onAddTestDetail()}
                            >
                              <BsPlusLg className="mx-2" />
                              แจ้งเลื่อนการทดสอบมาตรฐานฝีมือแรงงาน
                            </button>
                          );
                        };

                        return (
                          <div className="">

                            <CreateTableComponent
                              column={COLUMNSTEST}
                              dataInput={detailExtendLawOccupationData}
                              FormInput={AddDetailTestBtn}
                              showEntrie={false}
                              showPage={false}
                            />

                            <Modal
                              isOpen={openModalTestForm}
                              toggle={modalToggleExtendTest}
                              style={{ maxWidth: "600px", width: "100%" }}
                              centered
                              // scrollable
                              className="modal-bordered"
                              backdrop={"static"}
                              keyboard={false}
                            >
                              <ModalHeader className="styled-modal text-center" toggle={modalToggleExtendTest}>
                                เลือกสาขาอาชีพและครั้งที่
                              </ModalHeader>
                              <ModalBody className="form-border">
                                <div style={{ maxWidth: "600px", width: "100%" }}>
                                  <Form autoComplete="off" className="">
                                    <div className="p-4">
                                      <FormGroup>
                                        <div>

                                          <Label>สาขาอาชีพ</Label>
                                          {touched.testId && errors.testId ? (
                                            <span className="text-left text-danger px-1">
                                              {errors.testId}
                                            </span>
                                          ) : null}
                                          <Field name="testId">
                                            {({ field, meta }) => (
                                              <Input
                                                type="select"
                                                className={meta.touched && meta.error ? "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"}
                                                {...field}
                                                onChange={(e) => {
                                                  handleChange(e)
                                                  setFieldValue("testTimeId", "--กรุณาเลือกครั้งที่ดำเนินการทดสอบ--")
                                                  getTestTimeId(e)
                                                }}
                                              >
                                                <option defaultValue={"--กรุณาเลือกสาขาอาชีพ--"}>
                                                  --กรุณาเลือกสาขาอาชีพ--
                                                </option>
                                                {lawOcuuByBorrowIdData.map((law, i) => (
                                                  <option
                                                    key={i}
                                                    value={law.testId}
                                                  >
                                                    {law.lawOcuupationName}
                                                  </option>
                                                ))}
                                              </Input>
                                            )}
                                          </Field>
                                        </div>
                                        <div>
                                          <Label className="mt-2">ครั้งที่ดำเนินการทดสอบ</Label>
                                          {touched.testTimeId && errors.testTimeId ? (
                                            <span className="text-left text-danger px-1">
                                              {errors.testTimeId}
                                            </span>
                                          ) : null}
                                          <Field name="testTimeId">
                                            {({ field, meta }) => (
                                              <Input
                                                type="select"
                                                className={meta.touched && meta.error ? "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"}
                                                {...field}
                                                onChange={(e) => {
                                                  handleChange(e)
                                                }}
                                              >
                                                <option defaultValue={"--กรุณาเลือกครั้งที่ดำเนินการทดสอบ--"}>
                                                  --กรุณาเลือกครั้งที่ดำเนินการทดสอบ--
                                                </option>
                                                {testTimeData.map((data, i) => (
                                                  <option
                                                    key={i}
                                                    value={data.testTimeId}
                                                  >
                                                    ครั้งที่ {data.time}
                                                  </option>
                                                ))}
                                              </Input>
                                            )}
                                          </Field>
                                          <ErrorMessage name="checkDuplicateTestValue" component={TextErrors} />
                                        </div>
                                      </FormGroup>
                                    </div>


                                    <ModalFooter className="d-flex justify-content-center">
                                      <button
                                        type="submit"
                                        className="btn-blue w-50"
                                      >
                                        กรอกข้อมูล
                                      </button>
                                    </ModalFooter>
                                  </Form>
                                </div>
                              </ModalBody>
                            </Modal>
                          </div>
                        );
                      }}
                      </Formik>

                      <Formik
                        initialValues={isTestEditing ? selectedTestItem : detailChangeTestInititalValues}
                        validationSchema={detailChangeCourseValidateSchema}
                        onSubmit={detailChangelawOcuuOnsubmit}
                        enableReinitialize
                      >{({ values, handleChange, handleBlur, setFieldValue, setValues, resetForm, errors, touched }) => {
                        // console.log(values)

                        async function GetAmphur(e) {
                          let postData = new FormData();
                          postData.append("provinceCode", e.target.value);

                          try {
                            const responseAmphur = await fetch("/api/MasterData/getAmphur", {
                              method: "POST",
                              body: postData,
                            });
                            const amphurData = await responseAmphur.json();
                            setAmphur(amphurData.dataenum);
                          } catch (err) {
                            // console.log("err =>" + err);
                          }
                        }

                        // ดึง master data ตำบล ที่อยู่ปัจจุบันที่ติดต่อได้
                        async function GetTumbon(e) {

                          let postData = new FormData();
                          postData.append("provinceCode", values.newProvinceCode);
                          postData.append("amphurCode", e.target.value);
                          try {
                            let responseTumbon = await fetch("/api/MasterData/getTumbon", {
                              method: "POST",
                              body: postData,
                            });
                            const tumbonData = await responseTumbon.json();
                            setTumbon(tumbonData.dataenum);
                          } catch (err) {
                            // console.log("err =>" + err);
                          }
                        }

                        // หา location_id ที่อยู่ปัจจุบันที่ติดต่อได้
                        async function GetLocationsId(e) {

                          let postData = new FormData();
                          postData.append("provinceCode", values.newProvinceCode);
                          postData.append("amphurCode", values.newAmphurCode);
                          postData.append("tumbonCode", e.target.value);
                          try {
                            let res = await fetch("/api/MasterData/getLocationId", {
                              method: "POST",
                              body: postData,
                            });
                            const locationId = await res.json();

                            let setLocationId = locationId.dataenum
                              .map(({ locationId }) => locationId)
                              .join()
                              .toString();
                            setFieldValue("locationId", setLocationId);
                            // console.log(setLocationId);
                          } catch (err) {
                            // console.log("err =>" + err);
                          }
                        }

                        return (
                          <Modal
                            isOpen={openModalDetailExtendTest}
                            toggle={modalToggleDetailExtendTest}
                            style={{ maxWidth: "960px", width: "100%" }}
                            className="modal-bordered"
                            backdrop={"static"}
                            keyboard={false}
                          >
                            <ModalHeader className="styled-modal text-center" toggle={modalToggleDetailExtendTest}>
                              รายละเอียดการแจ้งเลื่อนการดำเนินการทดสอบมาตรฐานฝีมือแรงงาน
                            </ModalHeader>
                            <ModalBody className="form-border m-5">
                              <div style={{ maxWidth: "960px", width: "100%" }}>
                                <Form
                                  autoComplete="off"
                                  className="p-4"
                                >
                                  {/* ข้อมูลเดิม */}
                                  {oldLawOcuuData.map((item, k) => (
                                    <>
                                      <Field
                                        name={`id`}
                                        type="text"
                                        style={{ display: "none" }}
                                        disabled={true}
                                      />
                                      <Field
                                        name={`testId`}
                                        style={{ display: "none" }}
                                        type="text"
                                        disabled={true}
                                      />
                                      <Field
                                        name={`testTimeId`}
                                        style={{ display: "none" }}
                                        type="text"
                                        disabled={true}
                                      />
                                      <Field
                                        name={`oldlawOcuupationName`}
                                        style={{ display: "none" }}
                                        type="text"
                                        disabled={true}
                                      />
                                      <Field
                                        name={`oldTime`}
                                        style={{ display: "none" }}
                                        type="text"
                                        disabled={true}
                                      />
                                      <Field
                                        name={`locationId`}
                                        disabled={true}
                                        style={{ display: "none" }}
                                      />

                                      <div style={{ lineHeight: "2rem" }}>
                                        <p className="text-white bg bg-primary text-center">ข้อมูลเดิม</p>
                                      </div>
                                      {/* ข้อมูลเดิม */}

                                      <div className="border border-1 mx-2">
                                        <FormGroup className="px-2 mt-3">
                                          <Label>ชื่อสาขาอาชีพ :</Label>
                                          <span className="mx-1 input-color">{item.lawOcuupationName}</span>
                                          <Label>ทดสอบครั้งที่ :</Label>
                                          <span className="mx-1 input-color">{item.time}</span>
                                          <div></div>
                                          <Label>วันที่เริ่มดำเนินการทดสอบฯ :</Label>
                                          <span className="mx-1 input-color">{item.startDate}</span>
                                          <div></div>
                                          <Label>วันที่สิ้นสุดการดำเนินการทดสอบฯ :</Label>
                                          <span className="mx-1 input-color">{item.endDate}</span>
                                        </FormGroup>
                                        <div>
                                          <Label className="px-2">สถานที่ดำเนินการทดสอบฯ</Label>
                                          <FormGroup className="px-2">
                                            <Label>เลขที่</Label>
                                            <span className="mx-1 input-color">{item.addressNo}</span>
                                            <Label>หมู่ที่:</Label>
                                            {item.moo ? <span className="mx-1 input-color">{item.moo}</span> : <span className="mx-1 input-color">-</span>}
                                            <Label>ซอย:</Label>
                                            {item.soi ? <span className="mx-1 input-color">{item.soi}</span> : <span className="mx-1 input-color">-</span>}
                                            <Label>ถนน:</Label>
                                            {item.street ? <span className="mx-1 input-color">{item.street}</span> : <span className="mx-1 input-color">-</span>}
                                            <Label>ตำบล:</Label>
                                            {item.tumbonName ? <span className="mx-1 input-color">{item.tumbonName}</span> : <span className="mx-1 input-color">-</span>}
                                            <Label>อำเภอ:</Label>
                                            {item.amphurName ? <span className="mx-1 input-color">{item.amphurName}</span> : <span className="mx-1 input-color">-</span>}
                                            <Label>จังหวัด:</Label>
                                            {item.provinceName ? <span className="mx-1 input-color">{item.provinceName}</span> : <span className="mx-1 input-color">-</span>}
                                            <Label>รหัสไปรษณีย์:</Label>
                                            {item.postCode ? <span className="mx-1 input-color">{item.postCode}</span> : <span className="mx-1 input-color">-</span>}
                                          </FormGroup>
                                        </div>
                                      </div>
                                      <div className="mt-3" style={{ lineHeight: "2rem" }}>
                                        <p className="text-white bg bg-primary text-center">ข้อมูลใหม่</p>
                                      </div>
                                      <Label
                                        for=""
                                      >
                                        เลื่อนระยะเวลาการดำเนินการทดสอบฯ
                                      </Label>
                                      <Input
                                        className="cus-type mx-2"
                                        type="checkbox"
                                        name="extendTestTime"
                                        onChange={(e) => {
                                          handleChange(e)
                                          setFieldValue("testId", item.testId)
                                          setFieldValue("testTimeId", item.testTimeId)
                                          setFieldValue("oldlawOcuupationName", item.lawOcuupationName)
                                          setFieldValue("oldTime", item.time)

                                        }}
                                        onBlur={handleBlur}
                                        value={values.extendTestTime}
                                        checked={values.extendTestTime}
                                      />
                                      <FormGroup row>
                                        <Label for="" sm={1}>
                                          วันที่
                                        </Label>
                                        <Col sm={5}>
                                          <Field name="newStartDate">
                                            {({ field, meta, form }) => {
                                              const selectedDate = field.value ? new Date(field.value) : null; // check if field.value is not null or undefined
                                              // console.log("select Data =>", selectedDate)
                                              const selectedDateInBE = selectedDate ? addYears(543, selectedDate) : null; // convert to Thai Buddhist
                                              const monthInThai = selectedDateInBE ? format(selectedDateInBE, 'MMMM', { locale: th }) : null;
                                              const formattedDate = selectedDateInBE ? format(selectedDateInBE, 'dd') + ' ' + monthInThai + ' ' + format(selectedDateInBE, 'yyyy') : null;


                                              return (
                                                <DatePicker
                                                  selected={selectedDate}
                                                  locale="th-buddhist"
                                                  showIcon
                                                  calendarClassName="thai-buddhist"
                                                  dateFormat="dd MMMM yyyy"
                                                  value={formattedDate}
                                                  disabled={values.extendTime === false}
                                                  isClearable={true}
                                                  placeholderText="กรุณาเลือก"
                                                  renderCustomHeader={renderCustomHeader}
                                                  onChange={(date) => {
                                                    if (date instanceof Date && !isNaN(date)) {
                                                      const year = date.getFullYear();
                                                      const month = String(date.getMonth() + 1).padStart(2, '0');
                                                      const day = String(date.getDate()).padStart(2, '0');
                                                      const formattedDate = `${year}-${month}-${day}`;
                                                      // console.log("format", typeof (formattedDate))
                                                      form.setFieldValue(field.name, formattedDate);
                                                    } else {
                                                      form.setFieldValue(field.name, "");
                                                    }
                                                  }}
                                                  customInput={
                                                    <Input
                                                      type="text"

                                                      className={
                                                        touched.cardExpireDate && errors.cardExpireDate
                                                          ? "input-error rounded-pill text-center input-color"
                                                          : "rounded-pill text-center input-color"
                                                      }
                                                      value={formattedDate}
                                                      onChange={() => { }}
                                                      onBlur={field.onBlur}
                                                    />
                                                  }
                                                />
                                              )
                                            }}
                                          </Field>
                                        </Col>
                                        <Label for="" sm={1}>
                                          ถึง
                                        </Label>
                                        <Col sm={5}>

                                          <Field name="newEndDate">
                                            {({ field, meta, form }) => {
                                              const selectedDate = field.value ? new Date(field.value) : null; // check if field.value is not null or undefined
                                              // console.log("select Data =>", selectedDate)
                                              const selectedDateInBE = selectedDate ? addYears(543, selectedDate) : null; // convert to Thai Buddhist
                                              const monthInThai = selectedDateInBE ? format(selectedDateInBE, 'MMMM', { locale: th }) : null;
                                              const formattedDate = selectedDateInBE ? format(selectedDateInBE, 'dd') + ' ' + monthInThai + ' ' + format(selectedDateInBE, 'yyyy') : null;


                                              return (
                                                <DatePicker
                                                  selected={selectedDate}
                                                  locale="th-buddhist"
                                                  showIcon
                                                  calendarClassName="thai-buddhist"
                                                  dateFormat="dd MMMM yyyy"
                                                  value={formattedDate}
                                                  disabled={values.extendTime === false}
                                                  isClearable={true}
                                                  placeholderText="กรุณาเลือก"
                                                  renderCustomHeader={renderCustomHeader}
                                                  onChange={(date) => {
                                                    if (date instanceof Date && !isNaN(date)) {
                                                      const year = date.getFullYear();
                                                      const month = String(date.getMonth() + 1).padStart(2, '0');
                                                      const day = String(date.getDate()).padStart(2, '0');
                                                      const formattedDate = `${year}-${month}-${day}`;
                                                      // console.log("format", typeof (formattedDate))
                                                      form.setFieldValue(field.name, formattedDate);
                                                    } else {
                                                      form.setFieldValue(field.name, "");
                                                    }
                                                  }}
                                                  customInput={
                                                    <Input
                                                      type="text"

                                                      className={
                                                        touched.cardExpireDate && errors.cardExpireDate
                                                          ? "input-error rounded-pill text-center input-color"
                                                          : "rounded-pill text-center input-color"
                                                      }
                                                      value={formattedDate}
                                                      onChange={() => { }}
                                                      onBlur={field.onBlur}
                                                    />
                                                  }
                                                />
                                              )
                                            }}
                                          </Field>
                                        </Col>
                                      </FormGroup>
                                      <Label
                                        for=""
                                      >
                                        เปลี่ยนแปลงสถานที่ดำเนินการทดสอบฯ
                                      </Label>
                                      <Input
                                        className="cus-type mx-2"
                                        type="checkbox"
                                        name="changeTestPlace"
                                        onChange={(e) => {
                                          handleChange(e)
                                          setFieldValue("testId", item.testId)
                                          setFieldValue("testTimeId", item.testTimeId)
                                          setFieldValue("oldlawOcuupationName", item.lawOcuupationName)
                                          setFieldValue("oldTime", item.time)
                                        }}
                                        onBlur={handleBlur}
                                        value={values.changeTestPlace}
                                        checked={values.changeTestPlace}
                                      />


                                      <FormGroup row className="mt-2">

                                        <Label for="" sm={4}>
                                          ชื่อสถานที่ดำเนินการทดสอบฯ
                                        </Label>
                                        <Col sm={8}>
                                          <Field
                                            name={`newLocationName`}
                                          >
                                            {({ field, meta }) => (
                                              <Input
                                                disabled={values.changeTestPlace === false}
                                                type="text"
                                                className="rounded-pill text-left input-color"
                                                {...field}
                                              />
                                            )}
                                          </Field>
                                        </Col>
                                      </FormGroup>
                                      <FormGroup row>
                                        <Label for="" sm={2}>
                                          เลขที่
                                        </Label>
                                        <Col sm={4}>
                                          <Field
                                            name={`newAddressNo`}
                                          >
                                            {({ field, meta }) => (
                                              <Input
                                                disabled={values.changeTestPlace === false}
                                                type="text"
                                                className="rounded-pill text-left input-color"
                                                {...field}
                                              />
                                            )}
                                          </Field>
                                        </Col>

                                        <Label for="moo" sm={2}>
                                          หมู่ที่
                                        </Label>
                                        <Col sm={4}>
                                          <Field
                                            name={`newMoo`}
                                          >
                                            {({ field, meta }) => (
                                              <Input
                                                disabled={values.changeTestPlace === false}
                                                type="text"
                                                className="rounded-pill text-left input-color"
                                                {...field}
                                              />
                                            )}
                                          </Field>
                                        </Col>
                                      </FormGroup>
                                      <FormGroup row>
                                        <Label for="soi" sm={2}>
                                          ซอย
                                        </Label>
                                        <Col sm={4}>
                                          <Field
                                            name={`newSoi`}
                                          >
                                            {({ field, meta }) => (
                                              <Input
                                                disabled={values.changeTestPlace === false}
                                                type="text"
                                                className="rounded-pill text-left input-color"
                                                {...field}
                                              />
                                            )}
                                          </Field>
                                        </Col>

                                        <Label for="street" sm={2}>
                                          ถนน
                                        </Label>
                                        <Col sm={4}>
                                          <Field
                                            name={`newStreet`}
                                          >
                                            {({ field, meta }) => (
                                              <Input
                                                disabled={values.changeTestPlace === false}
                                                type="text"
                                                className="rounded-pill text-left input-color"
                                                {...field}
                                              />
                                            )}
                                          </Field>
                                        </Col>
                                      </FormGroup>

                                      <FormGroup row>
                                        <Label for="" sm={2}>
                                          จังหวัด
                                        </Label>
                                        <Col sm={4}>
                                          <Field
                                            name={`newProvinceCode`}
                                          >
                                            {({ field, form, meta }) => (
                                              <Input
                                                disabled={values.changeTestPlace === false}
                                                type="select"
                                                className="rounded-pill text-center input-color"
                                                {...field}
                                                onChange={(e) => {
                                                  handleChange(e);
                                                  GetAmphur(e);
                                                }}
                                              >
                                                <option
                                                  defaultValue={"กรุณาเลือกจังหวัด"}
                                                >
                                                  กรุณาเลือกจังหวัด
                                                </option>
                                                {province.map((p) => (
                                                  <option
                                                    key={p.provinceCode}
                                                    value={String(
                                                      p.provinceCode
                                                    )}
                                                  >
                                                    {p.provinceName}
                                                  </option>
                                                ))}
                                              </Input>
                                            )}
                                          </Field>
                                        </Col>

                                        <Label for="" sm={2}>
                                          อำเภอ/เขต
                                        </Label>
                                        <Col sm={4}>
                                          <Field
                                            name={`newAmphurCode`}
                                          >
                                            {({ field, form, meta }) => (
                                              <Input
                                                disabled={values.changeTestPlace === false}
                                                type="select"
                                                className="rounded-pill text-center input-color"
                                                {...field}
                                                onChange={(e) => {
                                                  handleChange(e);
                                                  GetTumbon(e);
                                                }}
                                              >
                                                <option
                                                  defaultValue={
                                                    "กรุณาเลือกอำเภอ/เขต"
                                                  }
                                                >
                                                  กรุณาเลือกอำเภอ/เขต
                                                </option>
                                                {amphur.map((a) => (
                                                  <option
                                                    key={a.amphurCode}
                                                    value={String(
                                                      a.amphurCode
                                                    )}
                                                  >
                                                    {a.amphurName}
                                                  </option>
                                                ))}
                                              </Input>
                                            )}
                                          </Field>
                                        </Col>
                                      </FormGroup>
                                      <FormGroup row>
                                        <Label sm={2}>
                                          ตำบล/แขวง
                                        </Label>
                                        <Col sm={4}>
                                          <Field
                                            name={`newTumbonCode`}
                                          >
                                            {({ field, meta }) => (
                                              <Input
                                                disabled={values.changeTestPlace === false}
                                                type="select"
                                                className="rounded-pill text-center input-color"
                                                {...field}
                                                onChange={(e) => {
                                                  handleChange(e);
                                                  GetLocationsId(e);
                                                }}
                                              >
                                                <option
                                                  defaultValue={
                                                    "กรุณาเลือกตำบล/แขวง"
                                                  }
                                                >
                                                  กรุณาเลือกตำบล/แขวง
                                                </option>
                                                {tumbon.map((t) => (
                                                  <option
                                                    key={t.tumbonCode}
                                                    value={String(
                                                      t.tumbonCode
                                                    )}
                                                  >
                                                    {t.tumbonName}
                                                  </option>
                                                ))}
                                              </Input>
                                            )}
                                          </Field>
                                        </Col>

                                        <Label for="postCode" sm={2}>
                                          รหัสไปรษณีย์
                                        </Label>
                                        <Col sm={4}>
                                          <Field
                                            name={`newPostCode`}
                                          >
                                            {({ field, meta }) => (
                                              <Input
                                                disabled={values.changeTestPlace === false}
                                                type="text"
                                                className="rounded-pill text-center input-color"
                                                {...field}
                                              />
                                            )}
                                          </Field>
                                        </Col>
                                      </FormGroup>
                                      <FormGroup row>
                                        <Label for="" sm={2}>
                                          โทรศัพท์
                                        </Label>
                                        <Col sm={4}>
                                          <Field
                                            name={`newPhone`}
                                          >
                                            {({ field, meta }) => (
                                              <Input
                                                disabled={values.changeTestPlace === false}
                                                type="text"
                                                className="rounded-pill text-center input-color"
                                                {...field}
                                              />
                                            )}
                                          </Field>
                                        </Col>

                                        <Label for="" sm={2}>
                                          โทรสาร
                                        </Label>
                                        <Col sm={4}>
                                          <Field
                                            name={`newFax`}
                                          >
                                            {({ field, meta }) => (
                                              <Input
                                                disabled={values.changeTestPlace === false}
                                                type="text"
                                                className="rounded-pill text-center input-color"
                                                {...field}
                                              />
                                            )}
                                          </Field>
                                        </Col>
                                      </FormGroup>
                                      <FormGroup row>
                                        <Label for="" sm={2}>
                                          โทรศัพท์มือถือ
                                        </Label>
                                        <Col sm={4}>
                                          <Field
                                            name={`newMobile`}
                                          >
                                            {({ field, meta }) => (
                                              <Input
                                                disabled={values.changeTestPlace === false}
                                                type="text"
                                                className="rounded-pill text-center input-color"
                                                {...field}
                                              />
                                            )}
                                          </Field>
                                        </Col>

                                        <Label for="email" sm={2}>
                                          อีเมล
                                        </Label>
                                        <Col sm={4}>
                                          <Field
                                            name={`newEmail`}
                                          >
                                            {({ field, meta }) => (
                                              <Input
                                                disabled={values.changeTestPlace === false}
                                                type="text"
                                                className="rounded-pill text-center input-color"
                                                {...field}
                                              />
                                            )}
                                          </Field>
                                        </Col>
                                      </FormGroup>
                                      <FormGroup row>
                                        <Label for="" sm={3}>
                                          แผนที่สถานที่ฝึกอบรม
                                        </Label>
                                        <Col sm={9}>
                                          <Field
                                            name={`newTestFLocationPath`}
                                          >
                                            {({ field, meta }) => {
                                              // console.log(form)
                                              return (
                                                <Input
                                                  disabled={values.changeTestPlace === false}
                                                  type="file"
                                                  className="rounded-pill text-center input-color"
                                                  {...field}
                                                  onChange={(e) => {
                                                    handleChange(e)
                                                    setFieldValue("newTestFLocationPath", e.currentTarget.files[0])
                                                  }}
                                                />
                                              );
                                            }}
                                          </Field>
                                        </Col>
                                      </FormGroup>
                                      <div className="d-flex justify-content-center align-items-center pt-4">
                                        <button type="submit" className="btn border border-1 mx-1">ยืนยัน</button>
                                        <button type="button" className="btn border border-1 mx-1">ยกเลิก</button>
                                      </div>

                                    </>
                                    // <>test</>
                                  ))}
                                </Form>
                              </div>
                            </ModalBody>
                          </Modal>
                        )
                      }}

                      </Formik>

                    </> : null}

                  <div className="d-flex justify-content-center align-items-center mt-5">
                    <button
                      type="submit"
                      className="btn-blue px-4 w-25"
                      disabled={submitLoading}
                    >
                      ส่งคำขอ
                    </button>
                  </div>
                </Form>
              </div>
            ) : (
              <Loading />
            )}
          </Container>
        );
      }}
    </Formik>
  );
}
